<template>
  <div
    class="c-banner l-flex"
    :style="bannerStyle"
  >
    <div
      v-if="timer"
      class="c-banner__timer"
      :title="formatTime"
    >
      {{ timer }}
    </div>
    <div
      v-for="(message, i) in messages"
      :key="i"
    >
      <div class="l-flex">
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="c-banner__message"
          v-html="message.title"
        />
        <!-- eslint-enable vue/no-v-html -->
        <a
          :href="message.linkUrl"
          class="c-banner__message-link"
        >
          {{ message.linkText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: "#14457F",
    },
    date: {
      type: String,
      default: null,
    },
    autoscroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      targetDate: null,
    };
  },
  computed: {
    bannerStyle() {
      const backgroundColor = this.backgroundColor;
      let result = { backgroundColor: backgroundColor };
      return result;
    },
    timer() {
      const date = this.date;
      let result;
      if (date) {
        const days = this.days;
        const hours = this.hours;
        const minutes = this.minutes;
        const seconds = this.seconds;
        result = `${days}:${hours}:${minutes}:${seconds}`;
        return result;
      } else {
        result = null;
      }
      return result;
    },
    formatTime() {
      const targetDate = new Date(this.date);
      let result;

      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // Get the month, day, hours, and minutes from the Date object
      const month = monthNames[targetDate.getMonth()];
      const day = targetDate.getDate();
      const hours = targetDate.getHours();
      const minutes = targetDate.getMinutes();
      result = `${month} ${day} ${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
      return result;
    },
  },
  mounted() {
    this.updateCountdown();
    setInterval(this.updateCountdown, 1000); // Update countdown every second
  },
  methods: {
    updateCountdown() {
      const currentDate = new Date().getTime();
      const targetDate = new Date(this.date).getTime();
      //for element title
      this.targetDate = targetDate;
      const timeRemaining = targetDate - currentDate;

      this.days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      this.seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-banner {
  width: 100%;
  text-align: center;
  padding: rem(10px) 0;
  &__timer,
  &__text {
    color: white;
    margin-right: rem(10px);
  }
  &__message-link {
    color: white;
    margin-left: rem(10px);
  }
}
</style>
